export default {

  /*组装树形数据*/
  buildTreeArr(arrData,id,parentid,children){
    const newArr = [];
    for(let i = 0; i < arrData.length; i++){
      if (arrData[i][parentid] == 0) {
        newArr.push(this.findChildren(arrData[i],arrData,id,parentid,children));
      }
    }
    return newArr;
  },
  findChildren(obj,arr,id,parentid,children){
    for(let i = 0; i < arr.length; i++){
      if (obj[id] == arr[i][parentid]) {
        if (obj[children] == null){
          obj[children] = [];
        }
        obj[children].push(this.findChildren(arr[i],arr,id,parentid,children));
      }
    }
    return obj;
  }

}
